export default "__VITE_ASSET__BqCugst5__"